module.exports = __webpack_public_path__ + "static/media/H2.4358ce52.PNG";